import React, { useState } from 'react';
import arrow_down from '../../assets/images/dropdown_triangle_down.svg';
import arrow_up from '../../assets/images/dropdown_triangle_up.svg';
import CheckBox from './CheckBox';

const VerticalMenu = ({title, items}) => {
    const [isOpen, setIsopen] = useState(false);

    const toggleDropDown = () => {
        setIsopen(isOpen => !isOpen)
    }

    return (
        <div className='flex-column'>
            <div role='button' className={`vertical-menu-botton flex-row space-between${isOpen ? " selected" : ""}`} onClick={toggleDropDown}>
                <span className='font-medium semibold light'>{title}</span>
                <img style={{height:"24px"}} src={isOpen ? arrow_up : arrow_down}/>
            </div>
            {isOpen && (
                <div className="flex-column">
                {Object.entries(items).map(([key, attributes], index) => (
                    <VerticalMenuItem key={index} title={key} attributes={attributes["vocab"]} allItems={items}/>
                ))}
                </div>
            )}
        </div>
    );
}

const VerticalMenuItem = ({title, attributes, allItems}) => {
    const [isOpen, setIsopen] = useState(false);
    const toggleDropDown = () => {
        setIsopen(isOpen => !isOpen)
    }

    return (
        <div className='flex-column'>
            <div role='button' className='vertical-menu-item flex-row space-between' onClick={toggleDropDown}>
                <span className='font-small semibold light'>{title}</span>
                <img style={{height:"24px"}} src={isOpen ? arrow_up : arrow_down}/>
            </div>
            {isOpen && (
                <div className="flex-column" style={{paddingLeft: "20px"}}>
                    {attributes.map((attribute, index) => (
                        <CheckBox
                        key={index}
                        attribute={title}
                        label={attribute}
                        defaultChecked={
                            Object.keys(allItems[attribute] || {}).includes("hidden")
                            ? !allItems[attribute]["hidden"].includes(attribute)
                            : true
                        }
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default VerticalMenu;

/*
defaultChecked={
                            Object.keys(metadata["toggleAttributes"][attribute] || {}).includes("hidden")
                            ? !metadata["toggleAttributes"][attribute]["hidden"].includes(attribute)
                            : true
                        }
*/